// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_intraday_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { LicenseType } from "../../bfftypes/v1/license_type_pb";
import { file_bfftypes_v1_license_type } from "../../bfftypes/v1/license_type_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import type { BiddingApprovalMode, BiddingLifecycleAction } from "./bidding_common_model_pb";
import { file_bffuser_v1_bidding_common_model } from "./bidding_common_model_pb";
import type { BiddingIntradayMarketAreaGroup } from "./bidding_intraday_market_model_pb";
import { file_bffuser_v1_bidding_intraday_market_model } from "./bidding_intraday_market_model_pb";
import type { BiddingIntradayCsvDateCount, BiddingIntradayCsvRowResult, BiddingIntradayDesiredPriceQuery, BiddingIntradayDesiredPriceResult, BiddingIntradayFeeAdjustedPriceQuery, BiddingIntradayFeeAdjustedPriceResult, BiddingIntradayFeeAutoConsiderState, BiddingIntradayFormulaPriceStatus, BiddingIntradayOrder, BiddingIntradayOrderBidMode, BiddingIntradayOrderFeeAutoConsiderInput, BiddingIntradayOrderFormula, BiddingIntradayOrderListItem, BiddingIntradayOrderOrderMethod, BiddingIntradayOrderScheduleEntryInput } from "./bidding_intraday_model_pb";
import { file_bffuser_v1_bidding_intraday_model } from "./bidding_intraday_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bidding_intraday_service.proto.
 */
export const file_bffuser_v1_bidding_intraday_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_license_type, file_bfftypes_v1_side, file_bffuser_v1_bidding_common_model, file_bffuser_v1_bidding_intraday_market_model, file_bffuser_v1_bidding_intraday_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * @generated from message bffuser.v1.ListBiddingIntradayOrdersRequest
 */
export type ListBiddingIntradayOrdersRequest = Message<"bffuser.v1.ListBiddingIntradayOrdersRequest"> & {
  /**
   * @generated from field: optional google.type.Date target_date_filter = 1;
   */
  targetDateFilter?: Date;

  /**
   * @generated from field: optional bfftypes.v1.AreaCode area_code_filter = 2;
   */
  areaCodeFilter?: AreaCode;

  /**
   * true の時だけ、 各札に JEPX 約定番号 (BiddingIntradayOrderListItem.jepx_execution_nos) を載せる。
   * 約定結果テーブルの列 (AC-BIN-022a) を出す画面が求める。 約定番号を使わない一覧 (受渡日で絞らない
   * 入札履歴など) は台帳を読ませないため求めない。
   *
   * @generated from field: bool include_jepx_execution_nos = 3;
   */
  includeJepxExecutionNos: boolean;
};

/**
 * Describes the message bffuser.v1.ListBiddingIntradayOrdersRequest.
 * Use `create(ListBiddingIntradayOrdersRequestSchema)` to create a new message.
 */
export const ListBiddingIntradayOrdersRequestSchema: GenMessage<ListBiddingIntradayOrdersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 0);

/**
 * @generated from message bffuser.v1.ListBiddingIntradayOrdersResponse
 */
export type ListBiddingIntradayOrdersResponse = Message<"bffuser.v1.ListBiddingIntradayOrdersResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.BiddingIntradayOrderListItem items = 1;
   */
  items: BiddingIntradayOrderListItem[];
};

/**
 * Describes the message bffuser.v1.ListBiddingIntradayOrdersResponse.
 * Use `create(ListBiddingIntradayOrdersResponseSchema)` to create a new message.
 */
export const ListBiddingIntradayOrdersResponseSchema: GenMessage<ListBiddingIntradayOrdersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 1);

/**
 * @generated from message bffuser.v1.GetBiddingIntradayOrderRequest
 */
export type GetBiddingIntradayOrderRequest = Message<"bffuser.v1.GetBiddingIntradayOrderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetBiddingIntradayOrderRequest.
 * Use `create(GetBiddingIntradayOrderRequestSchema)` to create a new message.
 */
export const GetBiddingIntradayOrderRequestSchema: GenMessage<GetBiddingIntradayOrderRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 2);

/**
 * @generated from message bffuser.v1.GetBiddingIntradayOrderResponse
 */
export type GetBiddingIntradayOrderResponse = Message<"bffuser.v1.GetBiddingIntradayOrderResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingIntradayOrder order = 1;
   */
  order?: BiddingIntradayOrder;
};

/**
 * Describes the message bffuser.v1.GetBiddingIntradayOrderResponse.
 * Use `create(GetBiddingIntradayOrderResponseSchema)` to create a new message.
 */
export const GetBiddingIntradayOrderResponseSchema: GenMessage<GetBiddingIntradayOrderResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 3);

/**
 * @generated from message bffuser.v1.CreateBiddingIntradayOrderRequest
 */
export type CreateBiddingIntradayOrderRequest = Message<"bffuser.v1.CreateBiddingIntradayOrderRequest"> & {
  /**
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 3;
   */
  timeCode: number;

  /**
   * @generated from field: bfftypes.v1.Side direction = 4;
   */
  direction: Side;

  /**
   * 入札価格 (円/kWh)。 fee_auto_consider と formula を指定しない時だけ設定する (成行は 0)。
   *
   * @generated from field: google.type.Decimal price_yen_per_kwh = 5;
   */
  priceYenPerKwh?: Decimal;

  /**
   * @generated from field: google.type.Decimal volume_mwh = 6;
   */
  volumeMwh?: Decimal;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalMode approval_mode = 7;
   */
  approvalMode: BiddingApprovalMode;

  /**
   * ゲートクローズ時刻。 編集 / 取下ガードに必要なので必須。
   *
   * @generated from field: google.protobuf.Timestamp gc_at = 8;
   */
  gcAt?: Timestamp;

  /**
   * 自動取消時刻 (AC-BIN-017)。 省略可 (= 自動取消を予約しない)。
   * 「現在時刻より後」 は usecase、 「gc_at 以前」(gc_at と同じ時刻は受理し、 gc_at より
   * 後だけ拒否) は domain entity が検証する。
   *
   * @generated from field: optional google.protobuf.Timestamp withdraw_at = 9;
   */
  withdrawAt?: Timestamp;

  /**
   * 発注主体 (= どの名義で JEPX に発注するか)。 未指定は業務上ありえないので拒否する。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 10;
   */
  issuerType: LicenseType;

  /**
   * 価格種別 (指値 / 成行、 AC-BIN-004d)。 UNSPECIFIED (= 未送信の旧クライアント
   * 互換) は BIDDING_INTRADAY_ORDER_ORDER_METHOD_LIMIT として扱う (BFF は backend の
   * 境界解決結果をそのまま転送するだけ)。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderOrderMethod order_method = 11;
   */
  orderMethod: BiddingIntradayOrderOrderMethod;

  /**
   * メモ（自由記述、任意）。 社内限定で JEPX へは送信しない。 100 文字以内 (AC-BIN-004)。
   *
   * @generated from field: optional string memo_free = 12;
   */
  memoFree?: string;

  /**
   * JEPX自由記述欄（任意）。 JEPX へ送信される。 70 文字以内 (AC-BIN-004)。
   *
   * @generated from field: optional string memo_jepx = 13;
   */
  memoJepx?: string;

  /**
   * 希望価格とプレビュー時の手数料自動考慮の状態。 指定時は backend が入札価格を決めて
   * 保存する (AC-BIN-004b)。 拒否条件は internalapi.v1.CreateIntradayOrderRequest.fee_auto_consider
   * を参照。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderFeeAutoConsiderInput fee_auto_consider = 14;
   */
  feeAutoConsider?: BiddingIntradayOrderFeeAutoConsiderInput;

  /**
   * フォーミュラ価格の入力値 (AC-BIN-005)。 指定時は backend が保存する時点の変数の値で
   * 1 回計算して入札価格にする (AC-BIN-020)。 拒否条件は
   * internalapi.v1.CreateIntradayOrderRequest.formula を参照。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderFormula formula = 15;
   */
  formula?: BiddingIntradayOrderFormula;

  /**
   * 操作元の業務ワークフローケース ID (画面を `?workflowId=` 付きで開いた経路)。 指定時、 backend は
   * 当該ケースが完了済 / 削除済なら FailedPrecondition で拒否し (AC-BIN-050 / AC-WFW-014)、
   * 拒否しなければ当該ケースの業務 ID (workflow_id) を札の来歴として記録する (AC-BIN-003)。
   * 省略 = ワークフロー非経由で、 拒否せず札は来歴を持たない。
   *
   * @generated from field: optional string case_id = 16;
   */
  caseId?: string;

  /**
   * フォーミュラの価格を手数料自動考慮 OFF として計算させる (AC-BIN-004b)。 formula と一緒の時だけ
   * 指定できる。 扱いは internalapi.v1.CreateIntradayOrderRequest.treat_fee_auto_consider_as_off を参照。
   *
   * @generated from field: bool treat_fee_auto_consider_as_off = 17;
   */
  treatFeeAutoConsiderAsOff: boolean;
};

/**
 * Describes the message bffuser.v1.CreateBiddingIntradayOrderRequest.
 * Use `create(CreateBiddingIntradayOrderRequestSchema)` to create a new message.
 */
export const CreateBiddingIntradayOrderRequestSchema: GenMessage<CreateBiddingIntradayOrderRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 4);

/**
 * @generated from message bffuser.v1.CreateBiddingIntradayOrderResponse
 */
export type CreateBiddingIntradayOrderResponse = Message<"bffuser.v1.CreateBiddingIntradayOrderResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingIntradayOrder order = 1;
   */
  order?: BiddingIntradayOrder;
};

/**
 * Describes the message bffuser.v1.CreateBiddingIntradayOrderResponse.
 * Use `create(CreateBiddingIntradayOrderResponseSchema)` to create a new message.
 */
export const CreateBiddingIntradayOrderResponseSchema: GenMessage<CreateBiddingIntradayOrderResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 5);

/**
 * target_date / area_code / time_code / gc_at / order_method は identity / 派生値で
 * 作成後 immutable のため Update には含めない (order_method の理由は internalapi 側
 * コメント参照)。 売/買 (direction) は下書きで
 * 変えられる (AC-BIN-007、 #8279)。
 *
 * @generated from message bffuser.v1.UpdateBiddingIntradayOrderRequest
 */
export type UpdateBiddingIntradayOrderRequest = Message<"bffuser.v1.UpdateBiddingIntradayOrderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 入札価格 (円/kWh)。 fee_auto_consider と formula を指定しない時だけ設定する (成行は 0)。
   * 指定すると保存済みのフォーミュラの入力値は外れる。
   *
   * @generated from field: google.type.Decimal price_yen_per_kwh = 2;
   */
  priceYenPerKwh?: Decimal;

  /**
   * @generated from field: google.type.Decimal volume_mwh = 3;
   */
  volumeMwh?: Decimal;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalMode approval_mode = 4;
   */
  approvalMode: BiddingApprovalMode;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 5;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * 発注主体区分。 作成後は変えられない (AC-BIN-007 の読み取り専用項目。 エリアと合わせて
   * 受渡契約コードを決めるため、 #8279)。 作成時の値をそのまま送り、 違う値は InvalidArgument。
   * 作成後に変わらない項目を Update に載せない決まりから外れるが、 既にある必須
   * field を消すと wire 互換が壊れるため残している。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 6;
   */
  issuerType: LicenseType;

  /**
   * メモ（自由記述、任意）。 社内限定で JEPX へは送信しない。 100 文字以内
   * (AC-BIN-007)。
   * 未指定なら保存済みの値を保ち、 空文字なら消す。
   *
   * @generated from field: optional string memo_free = 7;
   */
  memoFree?: string;

  /**
   * JEPX自由記述欄（任意）。 JEPX へ送信される。 70 文字以内 (AC-BIN-007)。
   * 未指定なら保存済みの値を保ち、 空文字なら消す。
   *
   * @generated from field: optional string memo_jepx = 8;
   */
  memoJepx?: string;

  /**
   * 自動取消時刻 (AC-BIN-017)。 未指定なら保存済みの値を保ち、 予約を外す時は
   * clear_withdraw_at を true にする。 「現在時刻より後」 (変えた時だけ) と 「gc_at 以前」 は
   * domain entity が検証する。
   *
   * @generated from field: optional google.protobuf.Timestamp withdraw_at = 9;
   */
  withdrawAt?: Timestamp;

  /**
   * 対向条件 (AC-BIN-114。 P0' は入力と保存のみで発動の自動実行は P1)。 4 項目をすべて
   * 未指定 (監視エリア群は空) にすると保存済みの値を保ち、 4 項目をそろえて送ると置き換える
   * (一部だけは InvalidArgument、 usecase が検証)。 外す時は clear_counter_condition を
   * true にする。
   * 戦略モードの札だけに付けられる (AC-BIN-114)。 入力の経路は未実装で、 付ける・変える
   * 編集は今はすべて domain entity が拒否する (InvalidArgument)。
   * 監視エリアは時間前板のエリア群から複数選択 (1 件以上・重複不可)。 閾値価格・発動時価格は
   * 0.01〜999 円/kWh、 発動時量は 0.1〜9999.9 MW。
   * 空配列は「未指定」なので min_items は付けない。 max_items は板のエリア群の数。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayMarketAreaGroup counter_condition_monitoring_area_groups = 10;
   */
  counterConditionMonitoringAreaGroups: BiddingIntradayMarketAreaGroup[];

  /**
   * @generated from field: optional google.type.Decimal counter_condition_threshold_price_yen_per_kwh = 11;
   */
  counterConditionThresholdPriceYenPerKwh?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal counter_condition_trigger_price_yen_per_kwh = 12;
   */
  counterConditionTriggerPriceYenPerKwh?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal counter_condition_trigger_volume_mw = 13;
   */
  counterConditionTriggerVolumeMw?: Decimal;

  /**
   * 売/買。 入札量・入札価格と同じく下書きで変えられる (AC-BIN-007、 #8279)。 未指定なら
   * 保存済みの値を保つ。
   *
   * @generated from field: optional bfftypes.v1.Side direction = 14;
   */
  direction?: Side;

  /**
   * true なら自動取消の予約を外す (withdraw_at と同時には指定できない)。
   *
   * @generated from field: bool clear_withdraw_at = 15;
   */
  clearWithdrawAt: boolean;

  /**
   * true なら対向条件を外す (対向条件の 4 項目と同時には指定できない)。
   *
   * @generated from field: bool clear_counter_condition = 16;
   */
  clearCounterCondition: boolean;

  /**
   * 希望価格とプレビュー時の手数料自動考慮の状態。 指定時は backend が入札価格を決めて
   * 保存する (AC-BIN-004b・AC-BIN-007。 売/買を変えた時は変えた後の売/買で算出する)。
   * 拒否条件は internalapi.v1.UpdateIntradayOrderRequest.fee_auto_consider を参照。
   * 手数料単価を取得できない間に OFF として扱う画面 (AC-BIN-004b) は、 こちらを送らず
   * price_yen_per_kwh だけを送る。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderFeeAutoConsiderInput fee_auto_consider = 17;
   */
  feeAutoConsider?: BiddingIntradayOrderFeeAutoConsiderInput;

  /**
   * フォーミュラ価格の入力値 (AC-BIN-005)。 指定時は更新する時点の変数の値で 1 回計算し直して
   * 入札価格にする (AC-BIN-020。 拒否の条件は internalapi.v1.CreateIntradayOrderRequest.formula
   * と同じ)。
   *
   * @generated from field: bffuser.v1.BiddingIntradayOrderFormula formula = 18;
   */
  formula?: BiddingIntradayOrderFormula;

  /**
   * 入札方式 (AC-BIN-005b)。 STRATEGY の場合 price_yen_per_kwh / volume_mwh は
   * backend が schedule_entries の最も早い段から導出する (送った値は使われない)。
   * 省略すると保存済みの入札方式とスケジュールを保つ (その時 schedule_entries は空)。
   *
   * @generated from field: optional bffuser.v1.BiddingIntradayOrderBidMode bid_mode = 19;
   */
  bidMode?: BiddingIntradayOrderBidMode;

  /**
   * 戦略モードのスケジュール。 NORMAL では空、 STRATEGY では 1 段以上。
   * 段数の上限は 48 (AC-BIN-005b。 domain entity の不変条件と同じ値)。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayOrderScheduleEntryInput schedule_entries = 20;
   */
  scheduleEntries: BiddingIntradayOrderScheduleEntryInput[];

  /**
   * 操作元の業務ワークフローケース ID。 扱いは CreateBiddingIntradayOrderRequest.case_id と同じ
   * (来歴の記録は Create だけ)。 加えて、 札の来歴のケースが完了済なら、 case_id の有無・値に
   * かかわらず backend が拒否する (AC-BIN-050)。 来歴の拒否は削除済のケースを対象にしない。
   *
   * @generated from field: optional string case_id = 21;
   */
  caseId?: string;

  /**
   * フォーミュラの更新を手数料自動考慮 OFF として計算させる (AC-BIN-004b・AC-BIN-007)。 扱いは
   * internalapi.v1.UpdateIntradayOrderRequest.treat_fee_auto_consider_as_off を参照。
   *
   * @generated from field: bool treat_fee_auto_consider_as_off = 22;
   */
  treatFeeAutoConsiderAsOff: boolean;
};

/**
 * Describes the message bffuser.v1.UpdateBiddingIntradayOrderRequest.
 * Use `create(UpdateBiddingIntradayOrderRequestSchema)` to create a new message.
 */
export const UpdateBiddingIntradayOrderRequestSchema: GenMessage<UpdateBiddingIntradayOrderRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 6);

/**
 * @generated from message bffuser.v1.UpdateBiddingIntradayOrderResponse
 */
export type UpdateBiddingIntradayOrderResponse = Message<"bffuser.v1.UpdateBiddingIntradayOrderResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingIntradayOrder order = 1;
   */
  order?: BiddingIntradayOrder;
};

/**
 * Describes the message bffuser.v1.UpdateBiddingIntradayOrderResponse.
 * Use `create(UpdateBiddingIntradayOrderResponseSchema)` to create a new message.
 */
export const UpdateBiddingIntradayOrderResponseSchema: GenMessage<UpdateBiddingIntradayOrderResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 7);

/**
 * @generated from message bffuser.v1.DeleteBiddingIntradayOrderRequest
 */
export type DeleteBiddingIntradayOrderRequest = Message<"bffuser.v1.DeleteBiddingIntradayOrderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * @generated from field: optional string case_id = 3;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.DeleteBiddingIntradayOrderRequest.
 * Use `create(DeleteBiddingIntradayOrderRequestSchema)` to create a new message.
 */
export const DeleteBiddingIntradayOrderRequestSchema: GenMessage<DeleteBiddingIntradayOrderRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 8);

/**
 * @generated from message bffuser.v1.DeleteBiddingIntradayOrderResponse
 */
export type DeleteBiddingIntradayOrderResponse = Message<"bffuser.v1.DeleteBiddingIntradayOrderResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteBiddingIntradayOrderResponse.
 * Use `create(DeleteBiddingIntradayOrderResponseSchema)` to create a new message.
 */
export const DeleteBiddingIntradayOrderResponseSchema: GenMessage<DeleteBiddingIntradayOrderResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 9);

/**
 * @generated from message bffuser.v1.TransitionBiddingIntradayOrderStateRequest
 */
export type TransitionBiddingIntradayOrderStateRequest = Message<"bffuser.v1.TransitionBiddingIntradayOrderStateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bffuser.v1.BiddingLifecycleAction action = 2;
   */
  action: BiddingLifecycleAction;

  /**
   * 差戻し理由。 action=REJECT のみ参照 (= REJECT 時 min_len=1 を usecase で検証、 他 action では無視)。
   * 上限は 100 文字 (input-character-limits.md の説明・メモ系 / approval-tasks.md の差戻しコメントと同値)。
   *
   * @generated from field: optional string reason = 3;
   */
  reason?: string;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 4;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * 操作元の業務ワークフローケース ID。 扱いは CreateBiddingIntradayOrderRequest.case_id と同じ
   * (来歴の記録は Create だけ)。 板取消・予約取消 (WITHDRAW) を含む全 action で、 case_id のケースが
   * 完了済 / 削除済なら拒否する (AC-WFW-014)。 申請取消 (CANCEL) と差戻し後再編集 (REOPEN) は、
   * 加えて札の来歴のケースが完了済なら case_id の有無・値にかかわらず拒否する (AC-BIN-050)。
   * 来歴の拒否は削除済のケースを対象にしない。
   *
   * @generated from field: optional string case_id = 5;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.TransitionBiddingIntradayOrderStateRequest.
 * Use `create(TransitionBiddingIntradayOrderStateRequestSchema)` to create a new message.
 */
export const TransitionBiddingIntradayOrderStateRequestSchema: GenMessage<TransitionBiddingIntradayOrderStateRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 10);

/**
 * @generated from message bffuser.v1.TransitionBiddingIntradayOrderStateResponse
 */
export type TransitionBiddingIntradayOrderStateResponse = Message<"bffuser.v1.TransitionBiddingIntradayOrderStateResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingIntradayOrder order = 1;
   */
  order?: BiddingIntradayOrder;
};

/**
 * Describes the message bffuser.v1.TransitionBiddingIntradayOrderStateResponse.
 * Use `create(TransitionBiddingIntradayOrderStateResponseSchema)` to create a new message.
 */
export const TransitionBiddingIntradayOrderStateResponseSchema: GenMessage<TransitionBiddingIntradayOrderStateResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 11);

/**
 * 時間前入札 CSV のチェック要求 (BFF)。 発注主体はスポット通常入札 CSV と違い
 * 行ごとの `発注主体区分` 列で決まるため request では受け取らない
 * (docs/specs/bidding/intraday-csv-import.md §2)。
 *
 * @generated from message bffuser.v1.CheckBiddingIntradayOrderCsvRequest
 */
export type CheckBiddingIntradayOrderCsvRequest = Message<"bffuser.v1.CheckBiddingIntradayOrderCsvRequest"> & {
  /**
   * CSV ファイルの生バイト列 (UTF-8 BOM / UTF-8 / Shift_JIS)。 業務上の上限 20 MB は
   * backend が文言付きで返す (ここは入札 CSV 共通の 50 MB で受ける)。
   *
   * @generated from field: bytes csv_content = 1;
   */
  csvContent: Uint8Array;

  /**
   * 投入 CSV ファイル名。任意。
   *
   * @generated from field: optional string csv_file_name = 2;
   */
  csvFileName?: string;
};

/**
 * Describes the message bffuser.v1.CheckBiddingIntradayOrderCsvRequest.
 * Use `create(CheckBiddingIntradayOrderCsvRequestSchema)` to create a new message.
 */
export const CheckBiddingIntradayOrderCsvRequestSchema: GenMessage<CheckBiddingIntradayOrderCsvRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 12);

/**
 * @generated from message bffuser.v1.CheckBiddingIntradayOrderCsvResponse
 */
export type CheckBiddingIntradayOrderCsvResponse = Message<"bffuser.v1.CheckBiddingIntradayOrderCsvResponse"> & {
  /**
   * 引換券。 ApplyBiddingIntradayOrderCsv に渡す。 有効期限 10 分・1 回消費。
   *
   * @generated from field: string check_token = 1;
   */
  checkToken: string;

  /**
   * 行ごとの差分プレビュー (CSV のデータ行順)。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayCsvRowResult rows = 2;
   */
  rows: BiddingIntradayCsvRowResult[];

  /**
   * 新規行数 (= 取込対象)。
   *
   * @generated from field: int32 created_count = 3;
   */
  createdCount: number;

  /**
   * エラー行数。 > 0 なら確定は全体拒否される。
   *
   * @generated from field: int32 error_count = 4;
   */
  errorCount: number;

  /**
   * 対象外行数 (発注主体区分未登録 / GC済み のいずれか)。
   * エラー行と違い確定はブロックしない。
   *
   * @generated from field: int32 excluded_count = 5;
   */
  excludedCount: number;

  /**
   * 受渡日ごとの新規行数 (AC-BCI-002、 CSV の受渡日初出順)。 対象外・エラーの行は数えない。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayCsvDateCount date_counts = 6;
   */
  dateCounts: BiddingIntradayCsvDateCount[];

  /**
   * 手数料自動考慮（時間前）が ON で手数料単価を取得できていない
   * (intraday-bidding.md AC-BIN-004b)。 true の間、 client は確定ボタンを
   * 無効化する。
   *
   * @generated from field: bool fee_auto_consider_unavailable = 7;
   */
  feeAutoConsiderUnavailable: boolean;
};

/**
 * Describes the message bffuser.v1.CheckBiddingIntradayOrderCsvResponse.
 * Use `create(CheckBiddingIntradayOrderCsvResponseSchema)` to create a new message.
 */
export const CheckBiddingIntradayOrderCsvResponseSchema: GenMessage<CheckBiddingIntradayOrderCsvResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 13);

/**
 * @generated from message bffuser.v1.ApplyBiddingIntradayOrderCsvRequest
 */
export type ApplyBiddingIntradayOrderCsvRequest = Message<"bffuser.v1.ApplyBiddingIntradayOrderCsvRequest"> & {
  /**
   * CheckBiddingIntradayOrderCsvResponse.check_token。
   *
   * @generated from field: string check_token = 1;
   */
  checkToken: string;
};

/**
 * Describes the message bffuser.v1.ApplyBiddingIntradayOrderCsvRequest.
 * Use `create(ApplyBiddingIntradayOrderCsvRequestSchema)` to create a new message.
 */
export const ApplyBiddingIntradayOrderCsvRequestSchema: GenMessage<ApplyBiddingIntradayOrderCsvRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 14);

/**
 * @generated from message bffuser.v1.ApplyBiddingIntradayOrderCsvResponse
 */
export type ApplyBiddingIntradayOrderCsvResponse = Message<"bffuser.v1.ApplyBiddingIntradayOrderCsvResponse"> & {
  /**
   * 実際に作成した注文の件数。
   *
   * @generated from field: int32 created_count = 1;
   */
  createdCount: number;

  /**
   * 作成した注文の ID (CSV のデータ行順)。
   *
   * @generated from field: repeated string order_ids = 2;
   */
  orderIds: string[];

  /**
   * 確定時点で再検証した行の実結果 (CSV のデータ行順)。
   * 対象外行も含み、遷移先の受渡日・表示範囲・対象外理由の算出に使う。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayCsvRowResult rows = 3;
   */
  rows: BiddingIntradayCsvRowResult[];
};

/**
 * Describes the message bffuser.v1.ApplyBiddingIntradayOrderCsvResponse.
 * Use `create(ApplyBiddingIntradayOrderCsvResponseSchema)` to create a new message.
 */
export const ApplyBiddingIntradayOrderCsvResponseSchema: GenMessage<ApplyBiddingIntradayOrderCsvResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 15);

/**
 * @generated from message bffuser.v1.PreviewBiddingIntradayOrderFeeAdjustedPricesRequest
 */
export type PreviewBiddingIntradayOrderFeeAdjustedPricesRequest = Message<"bffuser.v1.PreviewBiddingIntradayOrderFeeAdjustedPricesRequest"> & {
  /**
   * 希望価格から入札価格を算出したい行。 空でもよい (手数料自動考慮の状態と
   * desired_price_queries の結果だけを返す)。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayFeeAdjustedPriceQuery queries = 1;
   */
  queries: BiddingIntradayFeeAdjustedPriceQuery[];

  /**
   * 保存済みの入札価格から希望価格を逆算したい行 (入札編集モーダルの希望価格の初期値)。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayDesiredPriceQuery desired_price_queries = 2;
   */
  desiredPriceQueries: BiddingIntradayDesiredPriceQuery[];
};

/**
 * Describes the message bffuser.v1.PreviewBiddingIntradayOrderFeeAdjustedPricesRequest.
 * Use `create(PreviewBiddingIntradayOrderFeeAdjustedPricesRequestSchema)` to create a new message.
 */
export const PreviewBiddingIntradayOrderFeeAdjustedPricesRequestSchema: GenMessage<PreviewBiddingIntradayOrderFeeAdjustedPricesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 16);

/**
 * @generated from message bffuser.v1.PreviewBiddingIntradayOrderFeeAdjustedPricesResponse
 */
export type PreviewBiddingIntradayOrderFeeAdjustedPricesResponse = Message<"bffuser.v1.PreviewBiddingIntradayOrderFeeAdjustedPricesResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingIntradayFeeAutoConsiderState fee_auto_consider = 1;
   */
  feeAutoConsider?: BiddingIntradayFeeAutoConsiderState;

  /**
   * queries と同じ順・同じ件数。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayFeeAdjustedPriceResult results = 2;
   */
  results: BiddingIntradayFeeAdjustedPriceResult[];

  /**
   * desired_price_queries と同じ順・同じ件数。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayDesiredPriceResult desired_price_results = 3;
   */
  desiredPriceResults: BiddingIntradayDesiredPriceResult[];
};

/**
 * Describes the message bffuser.v1.PreviewBiddingIntradayOrderFeeAdjustedPricesResponse.
 * Use `create(PreviewBiddingIntradayOrderFeeAdjustedPricesResponseSchema)` to create a new message.
 */
export const PreviewBiddingIntradayOrderFeeAdjustedPricesResponseSchema: GenMessage<PreviewBiddingIntradayOrderFeeAdjustedPricesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 17);

/**
 * field 番号は internalapi.v1.ListIntradayActiveOrderCountsRequest と揃える。
 * organization_id (internalapi 版の 1) は認証情報から決まるため持たず、 1 は空ける。
 *
 * @generated from message bffuser.v1.ListBiddingIntradayActiveOrderCountsRequest
 */
export type ListBiddingIntradayActiveOrderCountsRequest = Message<"bffuser.v1.ListBiddingIntradayActiveOrderCountsRequest"> & {
  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * 数える札のエリア。 呼び出し元が業務エリアと JEPX の取引対象の 9 エリア (沖縄を除く。
   * conventions.md「画面ごとの対象エリア」) の共通部分を渡す。 他の List 系 RPC の
   * 「空 = 絞り込みなし」とは違い、 空は拒否する (1 件以上・重複なし)。
   *
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 3;
   */
  areaCodes: AreaCode[];
};

/**
 * Describes the message bffuser.v1.ListBiddingIntradayActiveOrderCountsRequest.
 * Use `create(ListBiddingIntradayActiveOrderCountsRequestSchema)` to create a new message.
 */
export const ListBiddingIntradayActiveOrderCountsRequestSchema: GenMessage<ListBiddingIntradayActiveOrderCountsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 18);

/**
 * field 番号は internalapi.v1.ListIntradayActiveOrderCountsResponse と揃える。
 *
 * @generated from message bffuser.v1.ListBiddingIntradayActiveOrderCountsResponse
 */
export type ListBiddingIntradayActiveOrderCountsResponse = Message<"bffuser.v1.ListBiddingIntradayActiveOrderCountsResponse"> & {
  /**
   * 48 コマ分を time_code の昇順で返す (0 件のコマも含む)。
   *
   * @generated from field: repeated bffuser.v1.ListBiddingIntradayActiveOrderCountsResponse.KomaCount counts = 1;
   */
  counts: ListBiddingIntradayActiveOrderCountsResponse_KomaCount[];
};

/**
 * Describes the message bffuser.v1.ListBiddingIntradayActiveOrderCountsResponse.
 * Use `create(ListBiddingIntradayActiveOrderCountsResponseSchema)` to create a new message.
 */
export const ListBiddingIntradayActiveOrderCountsResponseSchema: GenMessage<ListBiddingIntradayActiveOrderCountsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 19);

/**
 * @generated from message bffuser.v1.ListBiddingIntradayActiveOrderCountsResponse.KomaCount
 */
export type ListBiddingIntradayActiveOrderCountsResponse_KomaCount = Message<"bffuser.v1.ListBiddingIntradayActiveOrderCountsResponse.KomaCount"> & {
  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 1;
   */
  timeCode: number;

  /**
   * 入札中の札の件数。
   *
   * @generated from field: int32 active_order_count = 2;
   */
  activeOrderCount: number;
};

/**
 * Describes the message bffuser.v1.ListBiddingIntradayActiveOrderCountsResponse.KomaCount.
 * Use `create(ListBiddingIntradayActiveOrderCountsResponse_KomaCountSchema)` to create a new message.
 */
export const ListBiddingIntradayActiveOrderCountsResponse_KomaCountSchema: GenMessage<ListBiddingIntradayActiveOrderCountsResponse_KomaCount> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 19, 0);

/**
 * field 番号は internalapi.v1.PreviewIntradayOrderFormulaPriceRequest と揃える。
 * organization_id (internalapi 版の 1) は認証情報から決まるため持たず、 1 は空ける。
 *
 * @generated from message bffuser.v1.PreviewBiddingIntradayOrderFormulaPriceRequest
 */
export type PreviewBiddingIntradayOrderFormulaPriceRequest = Message<"bffuser.v1.PreviewBiddingIntradayOrderFormulaPriceRequest"> & {
  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 3;
   */
  timeCode: number;

  /**
   * 札のエリア。 手数料自動考慮 ON の入札価格の算出と入札制限の判定に使う (変数を求める
   * エリアは formula の参照エリア)。
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * 札の売/買。 手数料自動考慮 ON の加減算の向きに使う。
   *
   * @generated from field: bfftypes.v1.Side direction = 5;
   */
  direction: Side;

  /**
   * @generated from field: bffuser.v1.BiddingIntradayOrderFormula formula = 6;
   */
  formula?: BiddingIntradayOrderFormula;

  /**
   * プレビューを手数料自動考慮 OFF として計算させる (AC-BIN-004b)。 扱いは
   * internalapi.v1.PreviewIntradayOrderFormulaPriceRequest.treat_fee_auto_consider_as_off を参照。
   *
   * @generated from field: bool treat_fee_auto_consider_as_off = 7;
   */
  treatFeeAutoConsiderAsOff: boolean;
};

/**
 * Describes the message bffuser.v1.PreviewBiddingIntradayOrderFormulaPriceRequest.
 * Use `create(PreviewBiddingIntradayOrderFormulaPriceRequestSchema)` to create a new message.
 */
export const PreviewBiddingIntradayOrderFormulaPriceRequestSchema: GenMessage<PreviewBiddingIntradayOrderFormulaPriceRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 20);

/**
 * field 番号は internalapi.v1.PreviewIntradayOrderFormulaPriceResponse と揃える。
 *
 * @generated from message bffuser.v1.PreviewBiddingIntradayOrderFormulaPriceResponse
 */
export type PreviewBiddingIntradayOrderFormulaPriceResponse = Message<"bffuser.v1.PreviewBiddingIntradayOrderFormulaPriceResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingIntradayFormulaPriceStatus status = 1;
   */
  status: BiddingIntradayFormulaPriceStatus;

  /**
   * 変数の値 (円/kWh)。 取得できた時だけ設定する。
   *
   * @generated from field: google.type.Decimal reference_price_yen_per_kwh = 2;
   */
  referencePriceYenPerKwh?: Decimal;

  /**
   * 計算結果 (円/kWh。 小数第 3 位を四捨五入した値。 手数料自動考慮 ON では希望価格、
   * OFF と treat_fee_auto_consider_as_off が true の時は入札価格そのもの)。
   * status が CALCULATED の時と、 計算結果が範囲外で NOT_CALCULABLE の時に設定する。
   *
   * @generated from field: google.type.Decimal formula_price_yen_per_kwh = 3;
   */
  formulaPriceYenPerKwh?: Decimal;

  /**
   * 組織の手数料自動考慮 (時間前) の状態 (treat_fee_auto_consider_as_off を true にしても組織の状態)。
   *
   * @generated from field: bffuser.v1.BiddingIntradayFeeAutoConsiderState fee_auto_consider = 4;
   */
  feeAutoConsider?: BiddingIntradayFeeAutoConsiderState;

  /**
   * 計算結果を希望価格として求めた入札価格。 status が CALCULATED の時だけ設定する。
   * treat_fee_auto_consider_as_off が true の時は OFF (計算結果のまま)。
   *
   * @generated from field: bffuser.v1.BiddingIntradayFeeAdjustedPriceResult order_price = 5;
   */
  orderPrice?: BiddingIntradayFeeAdjustedPriceResult;

  /**
   * 変数の値を求めた範囲 (AC-BIN-005)。 意味は internalapi.v1.PreviewIntradayOrderFormulaPriceResponse
   * の reference_scope と同じ。
   *
   * @generated from oneof bffuser.v1.PreviewBiddingIntradayOrderFormulaPriceResponse.reference_scope
   */
  referenceScope: {
    /**
     * @generated from field: bfftypes.v1.AreaCode reference_scope_area_code = 6;
     */
    value: AreaCode;
    case: "referenceScopeAreaCode";
  } | {
    /**
     * @generated from field: bool reference_scope_system_price = 7;
     */
    value: boolean;
    case: "referenceScopeSystemPrice";
  } | {
    /**
     * @generated from field: bffuser.v1.BiddingIntradayMarketAreaGroup reference_scope_area_group = 8;
     */
    value: BiddingIntradayMarketAreaGroup;
    case: "referenceScopeAreaGroup";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.PreviewBiddingIntradayOrderFormulaPriceResponse.
 * Use `create(PreviewBiddingIntradayOrderFormulaPriceResponseSchema)` to create a new message.
 */
export const PreviewBiddingIntradayOrderFormulaPriceResponseSchema: GenMessage<PreviewBiddingIntradayOrderFormulaPriceResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 21);

/**
 * 一括板取消の対象 1 札 (AC-BIN-112)。 field 番号は internalapi.v1.IntradayOrderBulkWithdrawTarget と揃える。
 *
 * @generated from message bffuser.v1.BiddingIntradayOrderBulkWithdrawTarget
 */
export type BiddingIntradayOrderBulkWithdrawTarget = Message<"bffuser.v1.BiddingIntradayOrderBulkWithdrawTarget"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 確定した時点で一覧が持っていた札の updated_at。 食い違う札は UPDATED_BY_OTHER で受け付けない。
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrderBulkWithdrawTarget.
 * Use `create(BiddingIntradayOrderBulkWithdrawTargetSchema)` to create a new message.
 */
export const BiddingIntradayOrderBulkWithdrawTargetSchema: GenMessage<BiddingIntradayOrderBulkWithdrawTarget> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 22);

/**
 * organization_id と operated_by は BFF が eauth セッションから詰める。
 *
 * @generated from message bffuser.v1.WithdrawBiddingIntradayOrdersRequest
 */
export type WithdrawBiddingIntradayOrdersRequest = Message<"bffuser.v1.WithdrawBiddingIntradayOrdersRequest"> & {
  /**
   * 取り消す札。 件数の上限は置かない。 id の重複は InvalidArgument (どの札も受け付けない)。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayOrderBulkWithdrawTarget targets = 1;
   */
  targets: BiddingIntradayOrderBulkWithdrawTarget[];

  /**
   * 操作元の業務ワークフローケース ID。 扱いは internalapi.v1.WithdrawIntradayOrdersRequest.case_id と同じ
   * (完了済 / 削除済・受渡日の違うケースはリクエスト全体を拒否する。 AC-WFW-014)。
   *
   * @generated from field: optional string case_id = 2;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.WithdrawBiddingIntradayOrdersRequest.
 * Use `create(WithdrawBiddingIntradayOrdersRequestSchema)` to create a new message.
 */
export const WithdrawBiddingIntradayOrdersRequestSchema: GenMessage<WithdrawBiddingIntradayOrdersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 23);

/**
 * @generated from message bffuser.v1.WithdrawBiddingIntradayOrdersResponse
 */
export type WithdrawBiddingIntradayOrdersResponse = Message<"bffuser.v1.WithdrawBiddingIntradayOrdersResponse"> & {
  /**
   * request の targets と同じ順・同じ件数。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayOrderBulkWithdrawResult results = 1;
   */
  results: BiddingIntradayOrderBulkWithdrawResult[];
};

/**
 * Describes the message bffuser.v1.WithdrawBiddingIntradayOrdersResponse.
 * Use `create(WithdrawBiddingIntradayOrdersResponseSchema)` to create a new message.
 */
export const WithdrawBiddingIntradayOrdersResponseSchema: GenMessage<WithdrawBiddingIntradayOrdersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 24);

/**
 * field 番号は internalapi.v1.IntradayOrderBulkWithdrawResult と揃える。
 *
 * @generated from message bffuser.v1.BiddingIntradayOrderBulkWithdrawResult
 */
export type BiddingIntradayOrderBulkWithdrawResult = Message<"bffuser.v1.BiddingIntradayOrderBulkWithdrawResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from oneof bffuser.v1.BiddingIntradayOrderBulkWithdrawResult.outcome
   */
  outcome: {
    /**
     * 取消を受け付けた札。 取消の成立 / 失敗確定は札の状態 (ListBiddingIntradayOrders) で観測する。
     *
     * @generated from field: bffuser.v1.BiddingIntradayOrderBulkWithdrawAccepted accepted = 2;
     */
    value: BiddingIntradayOrderBulkWithdrawAccepted;
    case: "accepted";
  } | {
    /**
     * @generated from field: bffuser.v1.BiddingIntradayOrderBulkWithdrawFailure failure = 3;
     */
    value: BiddingIntradayOrderBulkWithdrawFailure;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrderBulkWithdrawResult.
 * Use `create(BiddingIntradayOrderBulkWithdrawResultSchema)` to create a new message.
 */
export const BiddingIntradayOrderBulkWithdrawResultSchema: GenMessage<BiddingIntradayOrderBulkWithdrawResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 25);

/**
 * @generated from message bffuser.v1.BiddingIntradayOrderBulkWithdrawAccepted
 */
export type BiddingIntradayOrderBulkWithdrawAccepted = Message<"bffuser.v1.BiddingIntradayOrderBulkWithdrawAccepted"> & {
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrderBulkWithdrawAccepted.
 * Use `create(BiddingIntradayOrderBulkWithdrawAcceptedSchema)` to create a new message.
 */
export const BiddingIntradayOrderBulkWithdrawAcceptedSchema: GenMessage<BiddingIntradayOrderBulkWithdrawAccepted> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 26);

/**
 * @generated from message bffuser.v1.BiddingIntradayOrderBulkWithdrawFailure
 */
export type BiddingIntradayOrderBulkWithdrawFailure = Message<"bffuser.v1.BiddingIntradayOrderBulkWithdrawFailure"> & {
  /**
   * @generated from field: bffuser.v1.BiddingIntradayOrderBulkWithdrawFailureReason reason = 1;
   */
  reason: BiddingIntradayOrderBulkWithdrawFailureReason;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrderBulkWithdrawFailure.
 * Use `create(BiddingIntradayOrderBulkWithdrawFailureSchema)` to create a new message.
 */
export const BiddingIntradayOrderBulkWithdrawFailureSchema: GenMessage<BiddingIntradayOrderBulkWithdrawFailure> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 27);

/**
 * 一括削除の対象 1 札 (AC-BIN-138)。 field 番号は internalapi.v1.IntradayOrderBulkDeleteTarget と揃える。
 *
 * @generated from message bffuser.v1.BiddingIntradayOrderBulkDeleteTarget
 */
export type BiddingIntradayOrderBulkDeleteTarget = Message<"bffuser.v1.BiddingIntradayOrderBulkDeleteTarget"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 確認ダイアログを開いた時点で一覧が持っていた札の updated_at。 食い違う札は UPDATED_BY_OTHER で削除しない。
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrderBulkDeleteTarget.
 * Use `create(BiddingIntradayOrderBulkDeleteTargetSchema)` to create a new message.
 */
export const BiddingIntradayOrderBulkDeleteTargetSchema: GenMessage<BiddingIntradayOrderBulkDeleteTarget> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 28);

/**
 * organization_id は BFF が eauth セッションから詰める。
 *
 * @generated from message bffuser.v1.DeleteBiddingIntradayOrdersRequest
 */
export type DeleteBiddingIntradayOrdersRequest = Message<"bffuser.v1.DeleteBiddingIntradayOrdersRequest"> & {
  /**
   * 削除する札。 件数の上限は置かない。 id の重複は InvalidArgument (どの札も削除しない)。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayOrderBulkDeleteTarget targets = 1;
   */
  targets: BiddingIntradayOrderBulkDeleteTarget[];

  /**
   * 操作元の業務ワークフローケース ID。 扱いは internalapi.v1.DeleteIntradayOrdersRequest.case_id と同じ
   * (完了済 / 削除済・受渡日の違うケースはリクエスト全体を拒否する。 AC-WFW-014)。
   *
   * @generated from field: optional string case_id = 2;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.DeleteBiddingIntradayOrdersRequest.
 * Use `create(DeleteBiddingIntradayOrdersRequestSchema)` to create a new message.
 */
export const DeleteBiddingIntradayOrdersRequestSchema: GenMessage<DeleteBiddingIntradayOrdersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 29);

/**
 * @generated from message bffuser.v1.DeleteBiddingIntradayOrdersResponse
 */
export type DeleteBiddingIntradayOrdersResponse = Message<"bffuser.v1.DeleteBiddingIntradayOrdersResponse"> & {
  /**
   * request の targets と同じ順・同じ件数。
   *
   * @generated from field: repeated bffuser.v1.BiddingIntradayOrderBulkDeleteResult results = 1;
   */
  results: BiddingIntradayOrderBulkDeleteResult[];
};

/**
 * Describes the message bffuser.v1.DeleteBiddingIntradayOrdersResponse.
 * Use `create(DeleteBiddingIntradayOrdersResponseSchema)` to create a new message.
 */
export const DeleteBiddingIntradayOrdersResponseSchema: GenMessage<DeleteBiddingIntradayOrdersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 30);

/**
 * field 番号は internalapi.v1.IntradayOrderBulkDeleteResult と揃える。
 *
 * @generated from message bffuser.v1.BiddingIntradayOrderBulkDeleteResult
 */
export type BiddingIntradayOrderBulkDeleteResult = Message<"bffuser.v1.BiddingIntradayOrderBulkDeleteResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from oneof bffuser.v1.BiddingIntradayOrderBulkDeleteResult.outcome
   */
  outcome: {
    /**
     * 削除した札。
     *
     * @generated from field: bffuser.v1.BiddingIntradayOrderBulkDeleteDeleted deleted = 2;
     */
    value: BiddingIntradayOrderBulkDeleteDeleted;
    case: "deleted";
  } | {
    /**
     * @generated from field: bffuser.v1.BiddingIntradayOrderBulkDeleteFailure failure = 3;
     */
    value: BiddingIntradayOrderBulkDeleteFailure;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrderBulkDeleteResult.
 * Use `create(BiddingIntradayOrderBulkDeleteResultSchema)` to create a new message.
 */
export const BiddingIntradayOrderBulkDeleteResultSchema: GenMessage<BiddingIntradayOrderBulkDeleteResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 31);

/**
 * @generated from message bffuser.v1.BiddingIntradayOrderBulkDeleteDeleted
 */
export type BiddingIntradayOrderBulkDeleteDeleted = Message<"bffuser.v1.BiddingIntradayOrderBulkDeleteDeleted"> & {
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrderBulkDeleteDeleted.
 * Use `create(BiddingIntradayOrderBulkDeleteDeletedSchema)` to create a new message.
 */
export const BiddingIntradayOrderBulkDeleteDeletedSchema: GenMessage<BiddingIntradayOrderBulkDeleteDeleted> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 32);

/**
 * @generated from message bffuser.v1.BiddingIntradayOrderBulkDeleteFailure
 */
export type BiddingIntradayOrderBulkDeleteFailure = Message<"bffuser.v1.BiddingIntradayOrderBulkDeleteFailure"> & {
  /**
   * @generated from field: bffuser.v1.BiddingIntradayOrderBulkDeleteFailureReason reason = 1;
   */
  reason: BiddingIntradayOrderBulkDeleteFailureReason;
};

/**
 * Describes the message bffuser.v1.BiddingIntradayOrderBulkDeleteFailure.
 * Use `create(BiddingIntradayOrderBulkDeleteFailureSchema)` to create a new message.
 */
export const BiddingIntradayOrderBulkDeleteFailureSchema: GenMessage<BiddingIntradayOrderBulkDeleteFailure> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_service, 33);

/**
 * internalapi.v1.IntradayOrderBulkWithdrawFailureReason の wire 値 mirror。 BFF が知らない値は UNSPECIFIED にする。
 *
 * @generated from enum bffuser.v1.BiddingIntradayOrderBulkWithdrawFailureReason
 */
export enum BiddingIntradayOrderBulkWithdrawFailureReason {
  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_BULK_WITHDRAW_FAILURE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 確定した時点の後に札が更新されていた (AC-BIN-123)。
   *
   * @generated from enum value: BIDDING_INTRADAY_ORDER_BULK_WITHDRAW_FAILURE_REASON_UPDATED_BY_OTHER = 1;
   */
  UPDATED_BY_OTHER = 1,

  /**
   * 板取消できる入札中の札ではない (予約中・送信中・最終結果・取消処理中など)。
   *
   * @generated from enum value: BIDDING_INTRADAY_ORDER_BULK_WITHDRAW_FAILURE_REASON_NOT_WITHDRAWABLE = 2;
   */
  NOT_WITHDRAWABLE = 2,

  /**
   * 札のコマの GC を過ぎていた。
   *
   * @generated from enum value: BIDDING_INTRADAY_ORDER_BULK_WITHDRAW_FAILURE_REASON_GATE_CLOSED = 3;
   */
  GATE_CLOSED = 3,

  /**
   * 札が見つからない (削除済みを含む)。
   *
   * @generated from enum value: BIDDING_INTRADAY_ORDER_BULK_WITHDRAW_FAILURE_REASON_NOT_FOUND = 4;
   */
  NOT_FOUND = 4,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayOrderBulkWithdrawFailureReason.
 */
export const BiddingIntradayOrderBulkWithdrawFailureReasonSchema: GenEnum<BiddingIntradayOrderBulkWithdrawFailureReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_service, 0);

/**
 * internalapi.v1.IntradayOrderBulkDeleteFailureReason の wire 値 mirror。 BFF が知らない値は UNSPECIFIED にする。
 *
 * @generated from enum bffuser.v1.BiddingIntradayOrderBulkDeleteFailureReason
 */
export enum BiddingIntradayOrderBulkDeleteFailureReason {
  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_BULK_DELETE_FAILURE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 確認ダイアログを開いた時点の後に札が更新されていた (AC-BIN-123)。
   *
   * @generated from enum value: BIDDING_INTRADAY_ORDER_BULK_DELETE_FAILURE_REASON_UPDATED_BY_OTHER = 1;
   */
  UPDATED_BY_OTHER = 1,

  /**
   * 下書きの札ではない。
   *
   * @generated from enum value: BIDDING_INTRADAY_ORDER_BULK_DELETE_FAILURE_REASON_NOT_DELETABLE = 2;
   */
  NOT_DELETABLE = 2,

  /**
   * 札のコマの GC を過ぎていた。
   *
   * @generated from enum value: BIDDING_INTRADAY_ORDER_BULK_DELETE_FAILURE_REASON_GATE_CLOSED = 3;
   */
  GATE_CLOSED = 3,

  /**
   * 札が見つからない (削除済みを含む)。
   *
   * @generated from enum value: BIDDING_INTRADAY_ORDER_BULK_DELETE_FAILURE_REASON_NOT_FOUND = 4;
   */
  NOT_FOUND = 4,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayOrderBulkDeleteFailureReason.
 */
export const BiddingIntradayOrderBulkDeleteFailureReasonSchema: GenEnum<BiddingIntradayOrderBulkDeleteFailureReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_service, 1);

/**
 * 時間前注文を frontend 向けに提供する service。
 *
 * @generated from service bffuser.v1.BiddingIntradayService
 */
export const BiddingIntradayService: GenService<{
  /**
   * 注文一覧。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayService.ListBiddingIntradayOrders
   */
  listBiddingIntradayOrders: {
    methodKind: "unary";
    input: typeof ListBiddingIntradayOrdersRequestSchema;
    output: typeof ListBiddingIntradayOrdersResponseSchema;
  },
  /**
   * 注文 1 件取得。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayService.GetBiddingIntradayOrder
   */
  getBiddingIntradayOrder: {
    methodKind: "unary";
    input: typeof GetBiddingIntradayOrderRequestSchema;
    output: typeof GetBiddingIntradayOrderResponseSchema;
  },
  /**
   * 注文を新規作成 (= 下書き状態)。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayService.CreateBiddingIntradayOrder
   */
  createBiddingIntradayOrder: {
    methodKind: "unary";
    input: typeof CreateBiddingIntradayOrderRequestSchema;
    output: typeof CreateBiddingIntradayOrderResponseSchema;
  },
  /**
   * 下書きの更新。 楽観ロック使用。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayService.UpdateBiddingIntradayOrder
   */
  updateBiddingIntradayOrder: {
    methodKind: "unary";
    input: typeof UpdateBiddingIntradayOrderRequestSchema;
    output: typeof UpdateBiddingIntradayOrderResponseSchema;
  },
  /**
   * 下書き状態の注文を削除。 楽観ロック使用。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayService.DeleteBiddingIntradayOrder
   */
  deleteBiddingIntradayOrder: {
    methodKind: "unary";
    input: typeof DeleteBiddingIntradayOrderRequestSchema;
    output: typeof DeleteBiddingIntradayOrderResponseSchema;
  },
  /**
   * 注文 lifecycle の状態遷移 (= 承認申請 / 承認 / 差戻し / 申請取消 / JEPX 提出 / 取下 / 差戻し後再編集 を action で指定)。
   * 共通 BiddingLifecycleAction を使用 (= spot と共通、 ただし intraday は WITHDRAW も有効)。
   * 楽観ロック使用。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayService.TransitionBiddingIntradayOrderState
   */
  transitionBiddingIntradayOrderState: {
    methodKind: "unary";
    input: typeof TransitionBiddingIntradayOrderStateRequestSchema;
    output: typeof TransitionBiddingIntradayOrderStateResponseSchema;
  },
  /**
   * 時間前入札 CSV のチェック (= 構文 + 業務検証 + 差分プレビュー、 副作用なし)。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayService.CheckBiddingIntradayOrderCsv
   */
  checkBiddingIntradayOrderCsv: {
    methodKind: "unary";
    input: typeof CheckBiddingIntradayOrderCsvRequestSchema;
    output: typeof CheckBiddingIntradayOrderCsvResponseSchema;
  },
  /**
   * 時間前入札 CSV の確定 (= check_token を引き換えて、 行ごとのエリアの承認モードどおりに
   * 承認申請または提出まで進める。 提出した札は JEPX へ送信される)。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayService.ApplyBiddingIntradayOrderCsv
   */
  applyBiddingIntradayOrderCsv: {
    methodKind: "unary";
    input: typeof ApplyBiddingIntradayOrderCsvRequestSchema;
    output: typeof ApplyBiddingIntradayOrderCsvResponseSchema;
  },
  /**
   * 手数料自動考慮 (時間前) の状態と、 希望価格から算出した入札価格を行ごとに返す
   * (intraday-bidding.md AC-BIN-004b / AC-BIN-104。 副作用なし)。 個別作成・一括作成・
   * 入札編集のモーダルが補足表示と値域・入札制限の判定に使う。 保存済みの入札価格から
   * 希望価格を逆算した値 (入札編集モーダルの初期値) も同じ呼び出しで返す。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayService.PreviewBiddingIntradayOrderFeeAdjustedPrices
   */
  previewBiddingIntradayOrderFeeAdjustedPrices: {
    methodKind: "unary";
    input: typeof PreviewBiddingIntradayOrderFeeAdjustedPricesRequestSchema;
    output: typeof PreviewBiddingIntradayOrderFeeAdjustedPricesResponseSchema;
  },
  /**
   * 受渡日の 48 コマそれぞれについて、 指定エリアにある自社の札のうち入札中
   * (intraday-bidding.md AC-BIN-035。 一部約定を含む) の件数を返す。 副作用なし。
   * 板発注画面の 48 コマリボン (AC-BIN-025) が使う。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayService.ListBiddingIntradayActiveOrderCounts
   */
  listBiddingIntradayActiveOrderCounts: {
    methodKind: "unary";
    input: typeof ListBiddingIntradayActiveOrderCountsRequestSchema;
    output: typeof ListBiddingIntradayActiveOrderCountsResponseSchema;
  },
  /**
   * フォーミュラ価格を、 呼び出した時点の変数の値で計算して返す (intraday-bidding.md
   * AC-BIN-005c のプレビュー。 副作用なし)。 変数の値が無い・計算できない時も RPC のエラーに
   * せず status で返す。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayService.PreviewBiddingIntradayOrderFormulaPrice
   */
  previewBiddingIntradayOrderFormulaPrice: {
    methodKind: "unary";
    input: typeof PreviewBiddingIntradayOrderFormulaPriceRequestSchema;
    output: typeof PreviewBiddingIntradayOrderFormulaPriceResponseSchema;
  },
  /**
   * 入札中の札を一括で板取消する (intraday-bidding.md AC-BIN-112)。 扱いは
   * internalapi.v1.IntradayOrderService.WithdrawIntradayOrders を参照。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayService.WithdrawBiddingIntradayOrders
   */
  withdrawBiddingIntradayOrders: {
    methodKind: "unary";
    input: typeof WithdrawBiddingIntradayOrdersRequestSchema;
    output: typeof WithdrawBiddingIntradayOrdersResponseSchema;
  },
  /**
   * 下書きの札を一括で削除する (intraday-bidding.md AC-BIN-138)。 扱いは
   * internalapi.v1.IntradayOrderService.DeleteIntradayOrders を参照。
   *
   * @generated from rpc bffuser.v1.BiddingIntradayService.DeleteBiddingIntradayOrders
   */
  deleteBiddingIntradayOrders: {
    methodKind: "unary";
    input: typeof DeleteBiddingIntradayOrdersRequestSchema;
    output: typeof DeleteBiddingIntradayOrdersResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_bidding_intraday_service, 0);

